import { apiGetRequest } from '../apiRequests';
import type { IPartner } from '@/types';

type IPartnerDTO = Pick<IPartner, 'id' | 'profile_id' | 'name' | 'slug'>;

export function getPartnerBySlug() {
  return apiGetRequest<IPartnerDTO | null>(`partner/slug/rate`);
}
